import { Universe } from '../../core/universes';
import { HydricStressTrend } from '../measurements.type';
import { mockedDevice } from './devices';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
import { mockedPlot } from './plots';
import { mockedStation } from './stations';
export const mockedSummaryData = {
    LW_D_12H: 13,
    T_X: 13,
    T_Xi: '1600552800',
    T_N: 13,
    FXY_D: 13,
    FF_L: 12,
    T_Ni: '1600552800',
    U_X: 13,
    U_Xi: '1600552800',
    U_N: 13,
    U_Ni: '1600552800',
    RR_L: 13,
    FXY_L: 13,
    DD_L: 13,
    T_DRY_X: 13,
    T_DRY_Xi: '1600552800',
    T_DRY_N: 13,
    T_DRY_Ni: '1600552800',
    T_DRY_L: 13,
    T_DRY_Li: '1600552800',
    T_WET_X: 13,
    T_WET_Xi: '1600552800',
    T_WET_N: 13,
    T_WET_Ni: '1600552800',
    T_WET_L: 13,
    T_WET_Li: '1600552800',
    LW_V_L: 13,
    LW_V_Li: '1600552800',
    FF_Li: '1600552800',
    RR_D: 12,
    RR_DD: 10,
    RR_H: 4,
    RR_Li: '1600552800',
    T_L: 12,
    T_Li: '1600552800',
    T_SOIL_L: 12,
    T_SOIL_Li: '1600552800',
    T_SOIL_N: 10,
    T_SOIL_Ni: '1600552800',
    T_SOIL_X: 14,
    T_SOIL_Xi: '1600552800',
    U_L: 88,
    U_Li: '1600552800',
    HPOT_D: {
        1: [10, 'saturation', HydricStressTrend.highDecrease],
        2: [64, 'vigilance', HydricStressTrend.stable],
        3: [120, 'stress', HydricStressTrend.highIncrease]
    },
    HPOT_DD: {
        1: [7, 'saturation', HydricStressTrend.highIncrease],
        2: [30, 'comfort', HydricStressTrend.highDecrease],
        3: [110, 'stress', HydricStressTrend.stable]
    },
    HPOT_7D: {
        1: [27, 'comfort', HydricStressTrend.highDecrease],
        2: [10, 'saturation', HydricStressTrend.highIncrease],
        3: [80, 'vigilance', HydricStressTrend.highIncrease]
    },
    HPOT_L: {
        1: [16, 'comfort', HydricStressTrend.stable],
        2: [76, 'vigilance', HydricStressTrend.highIncrease],
        3: [100, 'stress', HydricStressTrend.highDecrease]
    },
    HPOT_Li: { 1: '1600552800', 2: '1600553000', 3: '1600552500' },
    U_CAPA_D: [26, 'vigilance', HydricStressTrend.highDecrease],
    U_CAPA_DD: [28, 'comfort', HydricStressTrend.highDecrease],
    U_CAPA_7D: [36, 'saturation', HydricStressTrend.highDecrease],
    U_CAPA_L: [24, 'stress', HydricStressTrend.highDecrease],
    U_CAPA_Li: '1600552800'
};
const franceBoundingBox = [-5.4534286, 41.2632185, 9.8678344, 51.268318];
export const mockedLocation = {
    coordinates: [0, 0, 0, 0],
    type: 'Point',
    bbox: franceBoundingBox
};
export const mockedHorizon = { id: 1, label: 'depth', value: 20 };
export const mockedPlotSummary = {
    data: mockedSummaryData,
    metadata: {
        plot: { ...mockedPlot, location: mockedLocation, hasVirtualDevice: mockedPlot.hasVirtualDevice }
    }
};
export const mockedDeviceSummary = {
    data: mockedSummaryData,
    metadata: {
        device: mockedDevice
    }
};
export const mockedStationSummary = {
    data: mockedSummaryData,
    metadata: {
        station: mockedStation
    }
};
export const mockedHistory1_1 = {
    before: 1627768800,
    since: 1625090400,
    values: {
        T_CAL: {
            avg: { '20': [{ timestamp: 1625090400, value: 12, serial: 'serial', source: 0 }] },
            max: { '20': [{ timestamp: 1625090400, value: 18, serial: 'serial', source: 0 }] },
            min: { '20': [{ timestamp: 1625090400, value: 6, serial: 'serial', source: 0 }] }
        }
    },
    horizons: { T_CAL: { '20': mockedHorizon } }
};
const deviceResponse = mockedPaginatedResponse([mockedDeviceSummary]);
const plotResponse = mockedPaginatedResponse([mockedPlotSummary]);
const plotsAndStationsResponse = mockedPaginatedResponse([mockedPlotSummary, mockedStationSummary]);
const mock = {
    devices: {
        histories: {
            get1_1: mockedRequester(mockedHistory1_1, 'measurements.devices.histories.get1_1'),
            download: mockedRequester({}, 'measurements.devices.histories.download')
        },
        summaries: {
            getAvailableUniverses: mockedRequester([Universe.weather, Universe.irrigation, Universe.frost], 'measurements.devices.summaries.getAvailableUniverses'),
            getAllPages: mockedRequester([mockedDeviceSummary], 'measurements.devices.summaries.getAllPages'),
            getMany: mockedRequester(deviceResponse, 'measurements.devices.summaries.getMany'),
            getManyUniv: mockedRequester(deviceResponse, 'measurements.devices.summaries.getManyUniv'),
            getOne: mockedRequester(mockedDeviceSummary, 'measurements.devices.summaries.getOne')
        }
    },
    plots: {
        histories: {
            get1_1: mockedRequester(mockedHistory1_1, 'measurements.plots.histories.get1_1'),
            download: mockedRequester({}, 'measurements.plots.histories.download'),
            export: mockedRequester({}, 'measurements.plots.histories.download')
        },
        summaries: {
            getAvailableUniverses: mockedRequester([Universe.weather, Universe.irrigation, Universe.frost], 'measurements.plots.summaries.getAvailableUniverses'),
            getAllPages: mockedRequester([mockedPlotSummary], 'measurements.plots.summaries.getAllPages'),
            getMany: mockedRequester(plotResponse, 'measurements.plots.summaries.getMany'),
            getManyUniv: mockedRequester(plotResponse, 'measurements.plots.summaries.getManyUniv'),
            getOne: mockedRequester(mockedPlotSummary, 'measurements.plots.summaries.getOne')
        }
    },
    stations: {
        summaries: {
            getOne: mockedRequester(mockedStationSummary, 'measurements.stations.summaries.getOne')
        },
        histories: {
            get1_1: mockedRequester(mockedHistory1_1, 'measurements.stations.histories.get1_1')
        }
    },
    plotsAndStations: {
        summaries: {
            getAvailableUniverses: mockedRequester([Universe.weather, Universe.irrigation, Universe.frost], 'measurements.plotsAndStations.summaries.getAvailableUniverses'),
            getMany: mockedRequester(plotsAndStationsResponse, 'measurements.plotsAndStations.summaries.getMany'),
            getAllPages: mockedRequester([mockedPlotSummary, mockedStationSummary], 'measurements.plotsAndStations.summaries.getAllPages')
        }
    }
};
export default mock;
